import { render } from "./PdfIntroduce.vue?vue&type=template&id=c2b3ceb8&scoped=true"
import script from "./PdfIntroduce.vue?vue&type=script&lang=js"
export * from "./PdfIntroduce.vue?vue&type=script&lang=js"

import "./PdfIntroduce.vue?vue&type=style&index=0&id=c2b3ceb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b3ceb8"]])

export default __exports__